import React from 'react'
import InfoContent from './InfoContent'
import styles from './styles.module.less'
export default ({ children, ...props }) => (
  <div className={styles.fullScreenCenter} {...props}>
    <InfoContent>{children}</InfoContent>
  </div>
)
